var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:25px;}.cls-2{fill:none;}.cls-3{font-size:125.2px;font-family:MyriadPro-Regular, Myriad Pro;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.26,
    y: 268.49,
    width: 659.57,
    height: 532.51,
    rx: 29.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 305.69,
    cy: 319.58,
    r: 97.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 471.35,
    cy: 347.36,
    r: 97.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.12,
    y: 316.11,
    width: 659.57,
    height: 523.97,
    rx: 29.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 526.25,
    y: 493.67,
    width: 249.37,
    height: 168.85,
    rx: 25.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 946.98,
    cy: 760.42,
    r: 97.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M988.27,578.1S992.29,427,863.66,427"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "875.09 465.48 839.13 420.54 888.2 398.27"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(903.2 804.49)"
  }, "C"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdraw);
export default __webpack_public_path__ + "static/media/ICON_Withdraw.d98dccce23bd7e017a97c9d13acfa9c4.svg";
export { ForwardRef as ReactComponent };